import styled from "styled-components";

export const Container = styled.div`
  background: #f0f2f4;
  min-height: 100vh;
`;

export const Content = styled.div`
  position: relative;
  overflow-y: auto;
  border-radius: 10px;
  height: 100%;
  display: flex;
  width: calc(100% - 20px);
  padding-top: 80px;
  margin: 0 auto;
  & > .side-bar {
    display: none;
  }
  @media (min-width: 769px) {
    padding-top: 80px;

    margin: 0 auto;
    & > * {
      width: 100%;
      margin-top: 20px;
    }
    & > .side-bar {
      width: 250px;
      margin-right: 20px;
    }
  }
  @media (min-width: 769px) {
    position: fixed;
    max-width: 1200px;
    height: calc(100vh - 80px);
    top: 80px;
    left: 300px;
    width: calc(100vw - 330px);
    & > .side-bar {
      display: block;
      width: 270px;
      margin-right: 20px;
      border-right: 1px solid #eee;
      padding-right: 20px;
    }
  }
`;
